<template>
  <align v-if="showFilterResults" class="filter-results">
    <div v-if="typeof results === 'number' && resultsString">
      <b>{{ resultsString }}</b> {{ results === 1 ? 'result' : 'results' }}
    </div>

    <align v-if="filterDescription" small-gap>
      <span>{{ filterDescription }}</span>

      <icon-button
        size="18"
        icon="close"
        @click="$emit('clear')"
      />
    </align>
  </align>
</template>

<script>
import { getFilterDescription } from '@cardladder/shared/utils/ladder.util';

export default {
  props: {
    results: Number,
    filters: Object,
    isFiltering: Boolean,
    translationMap: Object,
    population: Number,
  },

  computed: {
    filterDescription() {
      return getFilterDescription(this.filters, this.translationMap, this.population);
    },

    showFilterResults() {
      return this.isFiltering && (this.filterDescription || this.resultsString);
    },

    resultsString() {
      if (!this.results && this.results !== 0) {
        return '';
      }

      return this.results === 10000 ? '>10,000' : this.$filters.number(this.results);
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-results {
  margin-top: $gp;
}
</style>
